import validate from "/home/ops/apps/spreadIt/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@emna_54e1eeff9af1bb30cc827381fe29a5f9/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/ops/apps/spreadIt/node_modules/.pnpm/nuxt@4.4.2_@babel+core@7.29.0_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@emna_54e1eeff9af1bb30cc827381fe29a5f9/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/ops/apps/spreadIt/app/middleware/auth.ts")
}